import { render } from "./BaseModalShell.vue?vue&type=template&id=d332d296"
import script from "./BaseModalShell.vue?vue&type=script&lang=js"
export * from "./BaseModalShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__